import FitnessProfile from "@/components/FitnessProfile/FitnessProfile";
import { WahooWorkoutTypeFamily } from "@WahooFitness/cloud-client-types";
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

const FitnessProfilePage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawProfile = searchParams.get("workout_type_family_id");
  const profile =
    rawProfile &&
    Object.values(WahooWorkoutTypeFamily).includes(+rawProfile as WahooWorkoutTypeFamily)
      ? (+rawProfile as WahooWorkoutTypeFamily)
      : null;

  const handleProfileChange = useCallback(
    (newProfile: WahooWorkoutTypeFamily) => {
      setSearchParams(
        (oldSearchParams) => {
          oldSearchParams.set("workout_type_family_id", newProfile.toString());
          return oldSearchParams;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  return (
    <FitnessProfile
      profile={profile ?? WahooWorkoutTypeFamily.Cycling}
      onProfileChange={handleProfileChange}
    />
  );
};

export default FitnessProfilePage;
